import React from 'react'
import api from './api'
import i18n from 'live/services/i18n'
import AdminHeader from 'live/components/header/ui/admin/header'
import ConfirmationDialog from 'live/components/actions/ui/confirmation-dialog'
import EditModal from './edit-modal'
import CreateDIPModal from './create-dip-modal'
import RigsSupervisorsView from './rig-supervisors-view'
import normalizeRigs from './normalize-rigs'
import { FormEnabledContext } from 'live/context/form-enabled'

export default class Main extends React.Component {
    static contextType = FormEnabledContext
    constructor (props) {
        super(props)

        this.state = {
            config: {},
            showConfWarning: true,
            rigLists: {
                exp: [],
                arap: [],
                aup: []
            },
            error: false,
            showErrors: false,
            saving: false,
            saved: false,
            loading: true,
            editing: false,
            creatingDIP: false
        }
    }

    UNSAFE_componentWillMount () {
        this.get()
    }

    componentDidMount () {
        document.title = 'Live: ' + i18n('Rig Supervisors Management')
    }

    get = (callback = false) => {

        api.get((data) => {
            let rigLists = data.rigLists
            let config = data.config

            rigLists = normalizeRigs(rigLists)

            this.setState({
                rigLists: rigLists,
                config: config,
                loading: false
            })

            if (callback)
                callback()
        })
    }

    toggleEdit = () => {
        this.setState({ editing: !this.state.editing })
    }

    toggleCreateDIP = () => {
        this.setState({ creatingDIP: !this.state.creatingDIP })
    }

    render () {
        const {
            showConfWarning,
            rigLists,
            config,
            loading
        } = this.state
        let showConfiguration = (config == null)
        const { readonly } = this.context

        return (
            <div className={'rig-supervisors-management admin-content ' + (loading ? 'loading' : '')}>
                <div className='admin-inner'>
                    <AdminHeader>
                        <h2>
                            <span>{i18n('Rig Supervisors Management')}</span>
                        </h2>
                    </AdminHeader>

                    <div className='admin-body'>

                        <div className="header" hidden={readonly}>
                            <div className="buttons">
                                <button className={'btn btn-primary'} onClick={this.toggleEdit}>
                                    <span><i className="fa fa-pencil-square-o"></i> {i18n('Edit')}</span>
                                </button>
                                <button className={'btn'} onClick={this.toggleCreateDIP}>
                                    <span><i className="fa fa-file-text-o"></i> {i18n('Create DIP')}</span>
                                </button>
                            </div>
                        </div>

                        <hr />

                        <RigsSupervisorsView
                            rigLists={rigLists}
                            rigsConfig={config}
                        />
                    </div>
                </div>

                {
                    showConfiguration && !readonly
                        ? <ConfirmationDialog
                            show={showConfWarning}
                            className="modal-xs"
                            title={i18n('Supervisor configuration not found')}
                            content={i18n("You haven't configured the number of rig supervisors by area yet.")}
                            btnText={i18n('Configure')}
                            btnStyle="primary"
                            apply={this.toggleEdit}
                            onHide={() => { this.setState({showConfWarning: false}) }}
                            />
                        : null
                }

                <EditModal
                    config={config}
                    onHide={this.toggleEdit}
                    onSave={this.get}
                    show={this.state.editing} />

                {
                    this.state.creatingDIP
                        ? <CreateDIPModal
                            onHide={this.toggleCreateDIP}
                            show={(!!this.state.creatingDIP)} />
                        : null
                }
            </div>
        )
    }

}
